import { SearchDocumentType, } from '../sdk.types';
export function parseTotals(responseData) {
    var _a;
    var facets = responseData.facets, nextPage = responseData.nextPage;
    if (!facets) {
        return {};
    }
    var totalResults = nextPage ? nextPage.total : null;
    var documentFacet = facets.find(function (f) { return f.facet === 'document_type'; });
    if (!documentFacet || typeof totalResults !== 'number') {
        return {};
    }
    return documentFacet.facets.reduce(function (totals, item) {
        totals[item.facetValue] = item.count;
        return totals;
    }, (_a = {},
        _a[SearchDocumentType.All] = totalResults,
        _a));
}
//# sourceMappingURL=facets.js.map